import { useQuery } from 'react-query';
import request from '../../../../../helpers/request';

export const key = (city) => ['shutdownNotifications', city];

const shutdownNotificationsQuery = async ({ queryKey }) => {
  const [_, city] = queryKey;

  return await request.get(
    `/Alert/notifications`,
    { city },
    `При загрузке служб, которым можно отправить уведомления, произошла ошибка`
  );
};

export const useShutdownNotifications = (city, options) =>
  useQuery(key(city), shutdownNotificationsQuery, options);
